import React, { useEffect, useState } from "react";
import rentalsService from "../../../services/rentals.service";

// A keyed loader prevents tags and expanded state from leaking between properties.
export default function PropertyTags({ properties }) {
  const propertyIds = JSON.stringify([...new Set(properties
    .map((property) => property.rental_id)
    .filter(Boolean).map(String))].sort());
  return <PropertyTagsForRentals key={propertyIds} propertyIds={propertyIds} />;
}

function PropertyTagsForRentals({ propertyIds }) {
  const [tags, setTags] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    let active = true;
    Promise.all(JSON.parse(propertyIds).map(async (id) => {
      try {
        const response = await rentalsService.getRental(id);
        return response.data?.tags || [];
      } catch {
        return [];
      }
    })).then((results) => {
      if (!active) return;
      const unique = new Map();
      results.flat().forEach((tag) => {
        // The rental endpoint also returns inherited destination tags.
        if (tag?.type !== "rental" || !tag.name?.trim()) return;
        unique.set(String(tag.id ?? tag.name), tag);
      });
      setTags([...unique.values()].sort((a, b) => a.name.localeCompare(b.name)));
    });
    return () => { active = false; };
  }, [propertyIds]);

  if (!tags.length) return null;

  return (
    <section className="message-property-tags hms-guest-identity-card" aria-label="Property tags">
      <button type="button" aria-expanded={expanded} onClick={() => setExpanded(!expanded)}>
        <span className="message-property-tags-label">
          <img src="/images/tag.svg" alt="" width="18" height="18" />
          <span>Tags ({tags.length})</span>
        </span>
        <span aria-hidden="true">{expanded ? "−" : "+"}</span>
      </button>
      {expanded && (
        <div className="hms-guest-tags">
          <div className="guest-tags">
            {tags.map((tag) => <div className="rental" key={tag.id ?? tag.name}>{tag.name}</div>)}
          </div>
        </div>
      )}
    </section>
  );
}
